import { useEffect, useRef, useState } from "react";
import { suggestCities } from "@/lib/cities";
import { MapPin } from "lucide-react";

export default function CityAutocomplete({ value, onChange, placeholder, testid }) {
  const [q, setQ] = useState(value || "");
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const ref = useRef(null);

  useEffect(() => { setQ(value || ""); }, [value]);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const handle = (v) => {
    setQ(v);
    setItems(suggestCities(v));
    setOpen(true);
    onChange({ label: v });
  };

  return (
    <div className="relative" ref={ref}>
      <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-slate-900/60 border border-slate-700/60 focus-within:border-[#FF6B6B]">
        <MapPin size={16} className="text-slate-400" />
        <input
          data-testid={testid}
          className="bg-transparent flex-1 outline-none text-sm text-white placeholder:text-slate-500"
          placeholder={placeholder}
          value={q}
          onChange={(e) => handle(e.target.value)}
          onFocus={() => { setItems(suggestCities(q)); setOpen(true); }}
        />
      </div>
      {open && items.length > 0 && (
        <div className="absolute z-30 mt-1 w-full glass-strong rounded-lg overflow-hidden shadow-xl">
          {items.map((it) => (
            <button
              type="button"
              key={it}
              data-testid={`${testid}-opt`}
              onClick={() => { setQ(it); onChange({ label: it }); setOpen(false); }}
              className="w-full text-left px-3 py-2 text-sm hover:bg-slate-800/70 flex items-center gap-2"
            >
              <MapPin size={14} className="text-slate-500" /> {it}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
